import {combineReducers} from "redux";

import common from "./common/reducer";
import journal from "./pages/journal/reducer";
import profile from "./pages/profile/reducer";
import plans from "./pages/plans/reducer";
import schedule from "./pages/schedule/reducer";
import rup from "./pages/rup/reducer";
import library from "./pages/library/reducer";
import printJournal from "./pages/printJournal/reducer";
import exam from "./pages/exam/reducer";
import psychologist from "./pages/psychologist/reducer";

//entrant
import admission from "./pages/admission/reducer";

export default combineReducers({
  common,
  journal,
  profile,
  plans,
  schedule,
  printJournal,
  rup,
  library,
  admission,
  exam,
  psychologist
})